import React, {Fragment} from "react";
import MatchAndEventMatchReportCard from "./MatchAndEventMatchReportCard";
import classNames from 'classnames';
import Divider from "../../../ui/Divider";
import {Image} from "react-bootstrap";

import '../../../../assets/sass/pages/match-and-event-match-report/match-stats-card.scss';
import ShadowScrollbars from "../../../ui/custom_scrollbars/ShadowScrollbars";
import {VideoItem} from "../../../ui/video_player/VideoItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// Style file
import '../../../../assets/sass/pages/match-and-event-match-report/match-videos-card.scss';
import Icon, {arrowToButton, share} from "../../../ui/Icon";

class MatchVideos extends MatchAndEventMatchReportCard {
    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => "Match Videos";

    /**
     * Renders the body of the card component.
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderVideos()}
            </Fragment>
        );
    };

    renderVideos = () => {
        const {videos} = this.props;

        return this.wrapWithinScrollbar(
            videos.map((video, index) => <MatchVideos.Item key={index}{...video}/>)
        );
    };

    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => ShadowScrollbars.wrap(content);

    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => classNames('match-and-event-match-report-card', 'match-videos-card');
}

MatchVideos.Item = props => {
    const {thumbnail, title, duration, onDownloadClick, onShareClick} = props;

    return (
        <div className="match-videos-card--item">
            <VideoItem title={title} thumbnail={thumbnail}/>
            <div className="d-flex flex-column flex-grow-1">
                <div className="d-flex flex-row justify-content-between align-content-center">
                    <div className="match-videos-card--item--title"> {title} </div>
                    <div className="d-flex">
                        <Icon className="match-videos-card--item--icon download primary" svg={arrowToButton}/>
                        <Icon className="match-videos-card--item--icon share primary" svg={share}/>
                    </div>
                </div>
                <div className="match-videos-card--item--duration"> {duration} </div>
            </div>
        </div>
    );
};

export default MatchVideos;
